import React from 'react'
import EmbedDashboard from '../components/EmbedDashboard'

function Bills() {
  return <EmbedDashboard dashboardName="BILLS" />
}

export default Bills
